import { styled } from "@mui/material";
import { LineChart } from "@mui/x-charts";

export const AssetRiskStyles = {
    LineChart: styled(LineChart)(({ theme }) => ({
        "& .MuiLineElement-root": {
            strokeWidth: 2,
        },
        "& .line-after path[class*='MuiLineElement-series-property']": {
            strokeDasharray: "10 5",
            stroke: "gray",
        },
        "& path[class*='MuiLineElement-series-property']": {
            cursor: "pointer",
        },
        // Mark
        "& .custom-mark": { cursor: "pointer", strokeWidth: 2 },
        "& .custom-mark:hover": { strokeWidth: 4 },
    })),
};
